module.exports = __webpack_public_path__ + "static/media/DSC03556.14dd727a.JPG";